// src/components/infografia/modals/ShapeSelectorModal.jsx
import React, { useState } from 'react';
import { FaTimes, FaSearch } from 'react-icons/fa';

const ShapeSelectorModal = ({ isOpen, onClose, onSelectShape }) => {
    const [searchTerm, setSearchTerm] = useState('');

    const shapes = [
        { id: 'rectangulo', name: 'Rectángulo', icon: '▬' },
        { id: 'cuadrado', name: 'Cuadrado', icon: '■' },
        { id: 'circulo', name: 'Círculo', icon: '●' },
        { id: 'elipse', name: 'Elipse/Óvalo', icon: '⬭' },
        { id: 'triangulo', name: 'Triángulo', icon: '▲' },
        { id: 'triangulo-equilatero', name: 'Triángulo Equilátero', icon: '△' },
        { id: 'rombo', name: 'Rombo', icon: '◆' },
        { id: 'paralelogramo', name: 'Paralelogramo', icon: '▱' },
        { id: 'trapecio', name: 'Trapecio', icon: '⏢' },
        { id: 'pentagono', name: 'Pentágono', icon: '⬟' },
        { id: 'hexagono', name: 'Hexágono', icon: '⬡' },
        { id: 'heptagono', name: 'Heptágono', icon: '⬢' },
        { id: 'octagono', name: 'Octágono', icon: '⯃' },
        { id: 'nonagono', name: 'Nonágono', icon: '⬣' },
        { id: 'decagono', name: 'Decágono', icon: '⬤' },
        { id: 'estrella', name: 'Estrella', icon: '★' },
        { id: 'flecha-derecha', name: 'Flecha Derecha', icon: '➡' },
        { id: 'flecha-izquierda', name: 'Flecha Izquierda', icon: '⬅' },
        { id: 'corazon', name: 'Corazón', icon: '♥' },
        { id: 'cruz', name: 'Cruz', icon: '✚' }
    ];

    const filteredShapes = shapes.filter(shape =>
        shape.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 overflow-y-auto bg-black bg-opacity-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[80vh] overflow-hidden flex flex-col">
                {/* Header */}
                <div className="p-6 border-b border-gray-200">
                    <div className="flex items-center justify-between mb-4">
                        <h3 className="text-lg font-semibold text-gray-900">
                            Seleccionar Forma
                        </h3>
                        <button
                            onClick={onClose}
                            className="text-gray-400 hover:text-gray-600"
                        >
                            <FaTimes className="w-6 h-6" />
                        </button>
                    </div>

                    {/* Búsqueda */}
                    <div className="relative">
                        <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                        <input
                            type="text"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            placeholder="Buscar forma..."
                            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>
                </div>

                {/* Lista de formas */}
                <div className="flex-1 overflow-y-auto p-6">
                    <div className="grid grid-cols-3 md:grid-cols-4 gap-4">
                        {filteredShapes.map((shape) => (
                            <button
                                key={shape.id}
                                onClick={() => {
                                    onSelectShape(shape);
                                    onClose();
                                }}
                                className="flex flex-col items-center justify-center p-4 border-2 border-gray-200 rounded-lg hover:border-blue-500 hover:bg-blue-50 transition-all group"
                            >
                                <div className="text-4xl mb-2 group-hover:scale-110 transition-transform">
                                    {shape.icon}
                                </div>
                                <span className="text-xs text-gray-700 text-center">
                                    {shape.name}
                                </span>
                            </button>
                        ))}
                    </div>

                    {filteredShapes.length === 0 && (
                        <div className="text-center py-8 text-gray-500">
                            No se encontraron formas
                        </div>
                    )}
                </div>

                {/* Footer */}
                <div className="p-6 border-t border-gray-200 flex justify-end">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300"
                    >
                        Cancelar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ShapeSelectorModal;

